export default __webpack_public_path__ + "static/media/garbage.16ae7bb8.svg";